import React from 'react';
import DatePicker from '@lingxi-common-component/sirius-ui/DatePicker';
import { ReactComponent as RangeDate } from '@/images/icons/edm/range-date.svg';
const { RangePicker } = DatePicker;
const defaultProps = {
    suffixIcon: React.createElement(RangeDate, null),
    dropdownClassName: 'edm-date-picker-dropdown-wrap',
};
const CustomerDatePicker = props => React.createElement(DatePicker, Object.assign({}, defaultProps, props));
const CustomerRangePicker = props => React.createElement(RangePicker, Object.assign({}, defaultProps, props));
CustomerDatePicker.RangePicker = CustomerRangePicker;
export default CustomerDatePicker;
